import React, { useState } from "react";
import plus from "../components/images/plus (2).png";
import Saly from "../components/images/Saly-1.png";
import "./Landing.css";

const LandingFour = () => {
  const [dropdowns, setDropdowns] = useState({
    isMentorPaid: false,
    isPlatformsIntegrated: false,
    isReceiveEarnings: false,
    isConvertToMentor: false,
    isHostEvents: false,
    isBuildCommunity: false,
  });

  const handleToggleDropdown = (dropdownName) => {
    setDropdowns((prevDropdowns) => ({
      ...prevDropdowns,
      [dropdownName]: !prevDropdowns[dropdownName],
    }));
  };
  return (
    <div className="flex justify-evenly items-start mt-[15vh] md:flex-col md:items-center md:mt-[8vh] mb-5 lg:flex-col lg:items-start lg:justify-center lg:h-scree">
      <div className="flex justify-center flex-col items-center  ">
        <div>
          {" "}
          <h1 className="text-5xl font-semibold mb-3 md:text-4xl ">
            Frequently Asked{" "}
          </h1>
          <div className="text-5xl font-semibold md:text-4xl md:text-center md:mb-3">
            Questions for event
            <img src={Saly} className="h-[55vh] md:hidden bounce lg:hidden" alt="" />
          </div>
        </div>
        <p className="text-xl text-[#848484] w-[82%] md:hidden">
          Still got questions? You might find the answer here
        </p>
        {/* <img src={Saly} className="h-[55vh] md:hidden bounce lg:hidden" alt=""/> */}
      </div>
      <div className="flex flex-col justify-start items-start w-[40%] md:w-[90%] gap-5 md:mx-4 md:mb-10 lg:w-[80%]">
        <div className="relative w-[100%] lg:w-[90%] lg:h-[80%] ">
          <div
            className="w-[100%] flex justify-between items-center shadow-xl border-[1px] p-7 rounded-xl gap-[20vh] md:gap-[10vh] hover:transform hover:scale-105 transition duration-300  "
            onClick={() => handleToggleDropdown("isMentorPaid")}
          >
            <p>Who should join the SKILLOP Society?</p>
            <img src={plus} className="cursor-pointer" alt="Plus" />
          </div>
          {dropdowns.isMentorPaid && (
            <div className="mt-4 w-[100%] bg-white shadow-md rounded-xl border-[1px] p-4 ">
              If you’re curious, technically serious, and willing to think, you belong here. This society is for students interested in Quantum Computing, IoT, cryptography, cybersecurity, and secure systems.
              If you’re just looking for certificates with zero effort, this is not the place. SKILLOP is built for students who want real skills, research exposure, and long-term technical growth.
            </div>
          )}
        </div>
        <div className="relative w-[100%] lg:w-[90%] lg:h-[80%]">
          <div
            className="w-[100%] flex justify-between items-center shadow-xl border-[1px] p-7 rounded-xl gap-[20vh] md:gap-[10vh] hover:transform hover:scale-105 transition duration-300"
            onClick={() => handleToggleDropdown("isPlatformsIntegrated")}
          >
            <p>Do I need prior knowledge in quantum computing or IoT?</p>
            <img src={plus} className="cursor-pointer" alt="Plus" />
          </div>
          {dropdowns.isPlatformsIntegrated && (
            <div className="mt-4 w-[100%] bg-white shadow-md rounded-xl border-[1px] p-4">
              No—but don’t confuse that with “no effort required.”
              You don’t need advanced background, but you must be willing to learn fundamentals properly. We start from basics (quantum mechanics for computing, networking, cryptography) and move toward advanced applications.
              If you’re lazy or expect spoon-feeding, you’ll fall behind fast.
            </div>
          )}
        </div>
        <div className="relative w-[100%] lg:w-[90%] lg:h-[80%]">
          <div
            className="w-[100%] flex justify-between items-center shadow-xl border-[1px] p-7 rounded-xl gap-[20vh] md:gap-[10vh] hover:transform hover:scale-105 transition duration-300"
            onClick={() => handleToggleDropdown("isReceiveEarnings")}
          >
            <p>What practical benefits will I gain by joining?</p>
            <img src={plus} className="cursor-pointer" alt="Plus" />
          </div>
          {dropdowns.isReceiveEarnings && (
            <div className="mt-4 w-[100%] bg-white shadow-md rounded-xl border-[1px] p-4">
              By joining SKILLOP, you gain:
              <br />
              • Strong foundational understanding of Quantum Computing, IoT, and secure communication systems.
              <br />
              • Hands-on experience through workshops, simulations, lab experiments, and real-world problem-solving.
              <br />
              • Exposure to cryptography, cybersecurity, and post-quantum security—skills rarely taught in regular coursework.
              <br />
              • Research experience, including problem formulation, experimentation, and technical documentation.
              <br />
              • Mentorship and preparation for national and international competitions, hackathons, and research challenges.
              <br />
              • Development of leadership, teamwork, and professional communication skills through active participation.
            </div>
          )}
        </div>
        <div className="relative w-[100%] lg:w-[90%] lg:h-[80%]">
          <div
            className="w-[100%] flex justify-between items-center shadow-xl border-[1px] p-7 rounded-xl gap-[20vh] md:gap-[10vh] hover:transform hover:scale-105 transition duration-300"
            onClick={() => handleToggleDropdown("isConvertToMentor")}
          >
            <p>What kind of culture does SKILLOP promote?</p>
            <img src={plus} className="cursor-pointer" alt="Plus" />
          </div>
          {dropdowns.isConvertToMentor && (
            <div className="mt-4 w-[100%] bg-white shadow-md rounded-xl border-[1px] p-4">
              A serious, ethical, and collaborative culture.
              <br /><br />
              We value:
              <br />
              • Academic honesty
              <br />
              • Responsible use of advanced technologies
              <br />
              • Clear thinking and technical depth over hype
              <br />
              • Solving real-world problems using practical, research-driven approaches
              <br />
              • Leadership through contribution and competence, not titles
              <br /><br />
              If you want a society that treats you like a professional-in-training rather than a passive attendee, SKILLOP is for you.
            </div>
          )}
        </div>
        {/* <div className="relative w-[100%] lg:w-[90%] lg:h-[80%]">
          <div
            className="w-[100%] flex justify-between items-center shadow-xl border-[1px] p-7 rounded-xl gap-[20vh] md:gap-[10vh] hover:transform hover:scale-105 transition duration-300"
            onClick={() => handleToggleDropdown("isHostEvents")}
          >
            <p>Are there any pre-event resources or workshops?</p>
            <img src={plus} className="cursor-pointer" alt="Plus" />
          </div>
          {dropdowns.isHostEvents && (
            <div className="mt-4 w-[100%] bg-white shadow-md rounded-xl border-[1px] p-4 mx-auto">
              Yes, recommended reading materials and resources will be provided
              to registered participants. Additionally, optional workshops on
              basic Machine Learning concepts and cryptic puzzles may be
              conducted prior to the event. Join the group <></>
              <a
                href="https://chat.whatsapp.com/GHLazSvAt83D6J7Gwbqb2A"
                className="text-blue-500 underline hover:text-blue-700"
                target="_blank"
                rel="noopener noreferrer"
              >
                 https://chat.whatsapp.com/GHLazSvAt83D6J7Gwbqb2A
              </a>
            </div>
          )}
        </div> */}
        <div className="relative w-[100%] lg:w-[90%] lg:h-[80%]">
          <div
            className="w-[100%] flex justify-between items-center shadow-xl border-[1px] p-7 rounded-xl gap-[20vh] md:gap-[10vh] hover:transform hover:scale-105 transition duration-300"
            onClick={() => handleToggleDropdown("isBuildCommunity")}
          >
            <p>Will SKILLOP help with competitions and career growth?</p>
            <img src={plus} className="cursor-pointer" alt="Plus" />
          </div>
          {dropdowns.isBuildCommunity && (
            <div className="mt-4 w-[100%] bg-white shadow-md rounded-xl border-[1px] p-4">
              Yes, but only if you put in the work.
              The society actively mentors students for national-level competitions, hackathons, and research challenges, including platforms associated with IITs and reputed institutions.
              Participation is earned through effort and contribution—not handed out randomly.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingFour;
